import { BaseCommand } from './baseCommand';
import Element, { ElementType } from '../element';
import { Legs } from '../legs/legs';
import store from '@/store';
import { ProductType } from '@/store/modules/product';
import { Vector2 } from '@babylonjs/core';
import { ShaderKeaRing } from '../shaders/others/shader_kea_ring';
import { stringUtil } from '../stringUtil';

export class ChangeKeaRingCommand extends BaseCommand {

    private existingKeaRing: Element | undefined;
    private removedElements: Element[] = [];
    private keaRingShaders = [
        'ShaderNBox',
        'ShaderNStozek',
        'ShaderNWalec',
    ];

    constructor(
        scenePreview: any,
        private legs: Legs,
    ) {
        super(scenePreview);
        this.existingKeaRing = this.scenePreview.elements
            .find((x: Element) => x.type === ElementType.KEA_RING)!;
    }

    public execute() {
        if (this.haveToAddKeaRing) {
            this.addKeaRing();
        }
        if (this.haveToRemoveKeaRing) {
            this.removeKeaRing();
        }
    }

    public revert() {
        super.revert();
        this.removedElements.forEach((x) => {
            this.scenePreview.elements.push(x);
            x.isVisible = true;
        });
    }

    private get haveToAddKeaRing(): boolean {
        return (
            !this.existingKeaRing &&
            this.keaRingShaders.includes(this.legs.shader.key) &&
            (store.getters.product.type === ProductType.CHEST_FURNITURE ||
                store.getters.product.type === ProductType.BEDSIDE_TABLE)
        );
    }

    private get haveToRemoveKeaRing(): boolean {
        return (
            this.existingKeaRing &&
            !this.keaRingShaders.includes(this.legs.shader.key) &&
            (store.getters.product.type === ProductType.CHEST_FURNITURE ||
                store.getters.product.type === ProductType.BEDSIDE_TABLE)
        );
    }

    private addKeaRing() {
        const model = stringUtil.createKeaRingModel();
        const light = '';
        const shader = new ShaderKeaRing();
        this.scenePreview.addElement(
            model,
            light,
            shader,
            Vector2.Zero(),
            Vector2.Zero(),
            (element: Element) => {
                this.elements.push(element);
            },
        );
    }

    private removeKeaRing() {
        this.scenePreview.elements.splice(
            this.scenePreview.elements.indexOf(this.existingKeaRing), 1,
        );
        this.existingKeaRing.isVisible = false;
        this.removedElements.push(this.existingKeaRing);
    }
}
